import React, { forwardRef } from "react";
import cx from 'classnames';
import { NewsroomResults } from "./NewsroomResults";

const NewsroomArchivePage = forwardRef((props: any, ref: any) => {
    return (
        <div ref={ref} data-id={props.cmsId} className={cx('px-xl-6 px-lg-5 px-4', props.editorClassObj)}>
            <div className="d-flex flex-wrap">
                <NewsroomResults title={props.title} limit={9} />
            </div>
        </div>
    );
});

export default NewsroomArchivePage;